<template>
    <div class="srv-profil">
        <header class="srv-head">
            <div class="srv-head-titre">Profil</div>
        </header>

        <div class="srv-corps">
            <div class="srv-id srv-carte">
                <div class="srv-id-avatar">{{ initiales }}</div>
                <div class="srv-id-txt">
                    <div class="srv-id-nom">{{ serveur.name }}</div>
                    <div class="srv-id-meta">Service ouvert {{ depuisQuand }}</div>
                </div>
            </div>

            <div class="srv-mini">
                <div class="srv-mini-c srv-carte">
                    <span class="srv-mini-lbl">Commandes</span>
                    <span class="srv-mini-val srv-num">{{ commandes.length }}</span>
                </div>
                <div class="srv-mini-c srv-carte">
                    <span class="srv-mini-lbl">En attente</span>
                    <span class="srv-mini-val srv-num attente">{{ nbAttente }}</span>
                </div>
                <div class="srv-mini-c srv-carte">
                    <span class="srv-mini-lbl">Total</span>
                    <span class="srv-mini-val srv-num">{{ fmt(total) }}</span>
                </div>
            </div>

            <button class="srv-item" @click="$emit('point-de-caisse')">
                <i class="ri-calculator-line"></i>
                <span class="srv-item-txt">
                    <span class="srv-item-nom">Point de caisse</span>
                    <span class="srv-item-sous">Bilan et clôture de fin de service</span>
                </span>
                <i class="ri-arrow-right-s-line srv-item-fl"></i>
            </button>

            <div class="srv-note">
                <i class="ri-shield-check-line"></i>
                <span>Vos informations restent sur ce téléphone.</span>
            </div>

            <button class="srv-btn srv-btn-danger srv-fin" @click="demander = true">
                <i class="ri-logout-box-line"></i>
                <span>Terminer le service</span>
            </button>
        </div>

        <div v-if="demander" class="srv-modal-overlay" @click.self="demander = false">
            <div class="srv-modal">
                <h2>Terminer le service ?</h2>
                <p class="srv-modal-txt">
                    Votre identité sera effacée de ce téléphone. Vous devrez rescanner
                    l'affiche du restaurant pour reprendre le service.
                </p>
                <p v-if="nbAttente" class="srv-modal-avert">
                    <i class="ri-error-warning-line"></i>
                    {{ nbAttente }} commande{{ nbAttente > 1 ? 's' : '' }} encore en attente de scan.
                </p>
                <div class="srv-modal-actions">
                    <button class="srv-btn srv-btn-sec" @click="demander = false">Annuler</button>
                    <button class="srv-btn srv-btn-danger" @click="$emit('terminer')">Terminer</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import { fmt } from "../menu/format";

    export default {
        name: "srvprofil",
        props: {
            serveur: { type: Object, required: true },
            commandes: { type: Array, default: () => [] },
        },
        emits: ["point-de-caisse", "terminer"],
        data: () => ({ demander: false }),
        computed: {
            initiales() {
                return String(this.serveur.name || "")
                    .split(/\s+/).filter(Boolean).slice(0, 2)
                    .map((m) => m[0]).join("").toUpperCase();
            },
            /** Depuis quand le service est ouvert - remplace le code et le téléphone,
                qui ne sont plus saisis depuis que l'identité vient de la caisse. */
            depuisQuand() {
                const t = this.serveur.depuis;
                if (!t) return "aujourd'hui";
                const h = new Date(t);
                return "depuis " + String(h.getHours()).padStart(2, "0")
                     + "h" + String(h.getMinutes()).padStart(2, "0");
            },
            nbAttente() { return this.commandes.filter((c) => c.statut === "attente").length; },
            total() {
                return this.commandes.reduce(
                    (s, c) => s + c.lignes.reduce((x, l) => x + l.pu * l.qte, 0), 0
                );
            },
        },
        methods: { fmt },
    };
</script>

<style scoped>
    .srv-profil { display: flex; flex-direction: column; min-height: 100vh; }

    .srv-id { display: flex; align-items: center; gap: var(--srv-md); padding: var(--srv-md); }
    .srv-id-avatar {
        width: 56px; height: 56px; border-radius: var(--srv-r-full); flex-shrink: 0;
        display: flex; align-items: center; justify-content: center;
        background: var(--srv-primary); color: var(--srv-on-primary);
        font-size: 20px; font-weight: 800; text-transform: uppercase;
    }
    .srv-id-txt { min-width: 0; }
    .srv-id-nom { font-size: 19px; font-weight: 700; }
    .srv-id-meta { margin-top: 2px; font-size: 14px; color: var(--srv-on-variant); }

    .srv-mini { display: grid; grid-template-columns: repeat(3, 1fr); gap: var(--srv-sm); margin-top: var(--srv-md); }
    .srv-mini-c { padding: 12px; min-width: 0; }
    .srv-mini-lbl {
        display: block; font-size: 10px; font-weight: 700;
        letter-spacing: .04em; text-transform: uppercase; color: var(--srv-on-variant);
    }
    .srv-mini-val { display: block; margin-top: 4px; font-size: 16px; font-weight: 800; overflow-wrap: anywhere; }
    .srv-mini-val.attente { color: var(--srv-primary); }

    .srv-item {
        display: flex; align-items: center; gap: var(--srv-md);
        width: 100%; min-height: 68px; padding: 0 var(--srv-md); margin-top: var(--srv-md);
        background: var(--srv-surface); color: var(--srv-on);
        border: 1px solid var(--srv-outline-variant); border-radius: var(--srv-r);
        font-family: inherit; text-align: left; cursor: pointer;
    }
    .srv-item:hover { border-color: var(--srv-primary); }
    .srv-item > i:first-child { font-size: 22px; color: var(--srv-primary); flex-shrink: 0; }
    .srv-item-txt { flex: 1; min-width: 0; }
    .srv-item-nom { display: block; font-size: 16px; font-weight: 700; }
    .srv-item-sous { display: block; margin-top: 2px; font-size: 13px; color: var(--srv-on-variant); }
    .srv-item-fl { font-size: 20px; color: var(--srv-outline); }

    .srv-note {
        display: flex; align-items: center; gap: 10px;
        margin-top: var(--srv-md); padding: 14px;
        background: var(--srv-surface-low);
        border: 1px solid var(--srv-outline-variant); border-radius: var(--srv-r);
        font-size: 14px; color: var(--srv-on-variant);
    }
    .srv-note i { font-size: 20px; color: var(--srv-success); flex-shrink: 0; }

    .srv-fin { margin-top: var(--srv-lg); }

    .srv-modal-overlay {
        position: fixed; inset: 0; z-index: 95;
        background: rgba(0, 0, 0, .65);
        display: flex; align-items: center; justify-content: center; padding: var(--srv-md);
    }
    .srv-modal {
        width: 100%; max-width: 400px; padding: var(--srv-lg);
        background: var(--srv-surface-low);
        border: 1px solid var(--srv-outline-variant); border-radius: 12px;
    }
    .srv-modal h2 { margin: 0 0 var(--srv-sm); font-size: 19px; font-weight: 700; }
    .srv-modal-txt { margin: 0; font-size: 14px; line-height: 20px; color: var(--srv-on-variant); }
    .srv-modal-avert {
        display: flex; align-items: flex-start; gap: 8px;
        margin: var(--srv-md) 0 0; padding: 10px;
        background: var(--srv-error-soft); border-radius: var(--srv-r-input);
        font-size: 13px; color: var(--srv-error);
    }
    .srv-modal-actions { display: flex; gap: var(--srv-sm); margin-top: var(--srv-md); }
</style>
